import { Component, OnInit, ViewChild } from '@angular/core';
import { MensagemService, RestricaoOperador, Restricoes, Restricao, ConsultaPaginada } from 'maestro-ng';
import { Pessoa } from '../pessoa.model';
import { PessoaService } from '../pessoa.service';
import { VirtualScroller } from 'primeng/virtualscroller';

@Component({
  selector: 'app-pessoa-lista',
  templateUrl: './pessoa-lista.component.html',
  styleUrls: ['./pessoa-lista.component.css'],
})
export class PessoaListaComponent implements OnInit {
  public quantidadeRegistros = 20;
  public pessoas: Pessoa[];
  public carregandoPessoas: boolean;
  public restricoes: Restricoes;
  public error = false;

  @ViewChild('vsPessoas')
  public vs: VirtualScroller;

  constructor(private service: PessoaService, private mensagemService: MensagemService) {
    this.restricoes = new Restricoes([
      new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'fonteDados.nome', operador: RestricaoOperador.START_WITH }),
      new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.START_WITH }),
    ]);
  }

  ngOnInit(): void {}

  pesquisar() {
    const primeiroCarregamento = this.pessoas === undefined;
    this.pessoas = Array.from({ length: this.quantidadeRegistros * 2 });
    if (this.vs !== undefined) {
      this.vs.scrollToIndex(0);
    }
    if (!primeiroCarregamento) {
      this.onLazyLoad(0);
    }
  }

  public onLazyLoad(firstResult: number): void {
    this.carregarPessoas(firstResult);
  }

  private carregarPessoas(firstResult?: number): void {
    this.carregandoPessoas = true;
    this.error = false;

    const consulta = new ConsultaPaginada();
    consulta.inicio = firstResult || 0;
    consulta.limite = this.quantidadeRegistros;
    consulta.restricoes = this.restricoes.getAtivas();
    consulta.contabilizar = false;

    this.service
      .recuperarPaginado(consulta)
      .then((resultado) => {
        const carregados = this.pessoas.filter((item) => item !== undefined);

        if (resultado.entidades.length === 0) {
          this.pessoas = carregados;
        } else if (resultado.entidades.length < this.quantidadeRegistros) {
          this.pessoas = carregados.concat(resultado.entidades);
        } else {
          this.pessoas = carregados.concat(resultado.entidades).concat(Array.from({ length: this.quantidadeRegistros * 2 }));
        }

        this.carregandoPessoas = false;
      })
      .catch((response) => {
        this.carregandoPessoas = false;
        this.error = true;
        this.mensagemService.addErro('Erro ao carregar os dados da pesquisa!', response.error);
      });
  }

  public limpar() {
    this.pessoas = undefined;
    this.restricoes.limpar();
  }
}
